// test2475
(2475 && 0);
